import { apiServer } from "../config";
import User from "../types/user";
import { fetchWithToken } from "./fetchWithToken";

export async function getSavedFilters(accessToken: string) {
  console.log("loading saved filters");
  const response = await fetchWithToken(
    apiServer + "/user/sync-user-accessibilty-preferences",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      accessibility_preferences: {
        id: number;
        user_id: number;
        name: string;
        created_at: string;
        updated_at: string;
        user_accessibility_preferences: {
          id: number;
          set_id: number;
          tag_id: number;
          created_at: string;
          updated_at: string;
        }[];
      }[];
    };
  };

  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function saveFilters(
  accessToken: string,
  selectedFilters: number[]
) {
  const formData = new FormData();
  formData.append("prefProfileName", "Default");
  formData.append("prefProfileId", "2");
  formData.append("selectedPrefTags", "[" + selectedFilters.join(",") + "]");
  console.log(formData);

  const response = await fetchWithToken(
    apiServer + "/user/profile-user-accessibility-preferences",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: User;
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}
